module.exports = __webpack_public_path__ + "img/chargers-map-mobile.1d095731.png";